import React, { useState } from "react";
import logo from './courosLogo.jpeg';
import './App.css';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

function App() {
  const [inputs, setInputs] = useState({
    nombre: '',
    correo: ''
  });
  function isMobile() {
    if (sessionStorage.desktop)
      return false;
    else if (localStorage.mobile)
      return true;
    var mobile = ['iphone', 'ipad', 'android', 'blackberry', 'nokia', 'opera mini', 'windows mobile', 'windows phone', 'iemobile'];
    for (var i in mobile)
      if (navigator.userAgent.toLowerCase().indexOf(mobile[i].toLowerCase()) > 0) return true;
    return false;
  }
  const enviarWhatsApp = () => {
    const urlDesktop = 'https://web.whatsapp.com/';
    const urlMobile = 'whatsapp://';
    const telefono = '573114827828';
    setTimeout(() => {
      let mensaje = 'send?phone=' + telefono + '&text=Hola Couros quisiera recibir un correo con sus productos%0ANombre: %0A' + inputs.nombre + '%0ACorreo: %0A' + inputs.correo + ''
      if (isMobile()) {
        window.open(urlMobile + mensaje, '_blank')
      } else {
        window.open(urlDesktop + mensaje, '_blank')
      }
    }, 3000);

    setInputs({
      nombre: '',
      correo: ''
    });
  };
  console.log(inputs);
  return (
    <span className="App">
      <img src={logo} className="App-logo" alt="logo" />
      <header className="App-header">
        <p className="Titulo">
          Couros
        </p>
        <p className="App-link" >
          Fabrica de artículos de cuero
        </p>
        <div className="beneficios">
          <p className="beneficio1">
            Experiencia de más de 30 años
           <br></br>
           desde 1990
        </p>
          <p className="beneficio1">
            Envíos nacionales
           <br></br>
           e internacionales
        </p>
          <p className="beneficio1">
            Calidad y servicio
          <br></br>
           a los mejores precios
        </p>
        </div>
        <div className="contactContainer">
          <TextField
            className="prueba"
            id="filled-correo-input"
            label="Correo"
            variant="filled"
            value={inputs.correo}
            onChange={(event) => setInputs({ ...inputs, correo: event.target.value })}
          />
          <TextField
            className="prueba"
            id="filled-nombre-input"
            label="Nombre"
            variant="filled"
            value={inputs.nombre}
            onChange={(event) => setInputs({ ...inputs, nombre: event.target.value })}
          />
          <Button onClick={() => enviarWhatsApp()} variant="contained" color="primary" className="boton">
            Contactanos
        </Button>
        </div>
      </header>
    </span>
  );
}

export default App;
